import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { type Role, ROLES } from "@/api/admins";
import { getAdminStoreState } from "@/stores";

const IntegrationsLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/integrations")({
  beforeLoad: () => {
    const { admin } = getAdminStoreState();

    const requiredPermissions: Role[] = [ROLES.super];

    if (!admin || !requiredPermissions.includes(admin.role)) {
      throw redirect({ to: "/$" });
    }
  },
  component: IntegrationsLayout,
});
